import { render, staticRenderFns } from "./SecurePayment.vue?vue&type=template&id=46633e32"
import script from "./SecurePayment.vue?vue&type=script&lang=js"
export * from "./SecurePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports